import * as angular from "angular";
import './SendgridContactListDialogComponent.scss';
import {SendGridContactListOptions} from "../../model/SendGridContactListOptions";

interface SendgridContactListDialogComponentScope {
    submit: () => void;
    cancel: () => void;
    sendGridOptions: SendGridContactListOptions;
}

export class SendgridContactListDialogComponent {

    private $scope: SendgridContactListDialogComponentScope;
    private $mdDialog: angular.material.IDialogService;

    public static instance = ($event: MouseEvent): angular.material.IDialogOptions => ({
        template: require('./SendgridContactList.dialog.component.html'),
        targetEvent: $event,
        fullscreen: false,
        clickOutsideToClose: true,
        parent: angular.element(document.body),
        controller: ['$scope', '$mdDialog', SendgridContactListDialogComponent]
    });

    constructor($scope: SendgridContactListDialogComponentScope,
                $mdDialog: angular.material.IDialogService) {
        this.$scope = $scope;
        this.$mdDialog = $mdDialog;
        $scope.cancel = this.cancel;
        $scope.submit = this.submit;
        $scope.sendGridOptions = {
            contactListName: "",
            onlySubscribers: true
        }
    }


    cancel = () => {
        this.$mdDialog.cancel();
    };

    submit = () => {
        this.$mdDialog.hide(this.$scope.sendGridOptions);
    }

}